import React from 'react';

import MyOrtMap from '../components/MyOrtMap';
import logo from '../assets/logo.png'; // Pfad ggf. anpassen
import { Link } from 'react-router-dom';
import './home.css'; // gleiche Styles wie bei Home verwenden

import Bodenfeuchte from '../components/Bodenfeuchte';


function BodenfeuchteMondsee() {
  return (
    <div className="home-container">
      <div className="home-diagramm">
        
      <div className='wetter-container'><h1 >BODENFEUCHTE</h1></div>
        <Bodenfeuchte ort="mondsee" />
      </div>
    </div>
  );
}

export default BodenfeuchteMondsee;
